import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import {
  Button,
  Button as MUIButton,
  Skeleton,
  Stack,
} from '@mui/material';
import { toaster } from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import api from '../../services/api';
import { debounce } from 'lodash';
import { address } from '../../schema/address';
import { SlidingPaneAddNew } from '../Page/SlidingPaneAddNew';
import { MoreOptions } from '../Table/assets/MoreOptions';
import { MapGoogle } from '../Map/MapGoogle';
import RoomIcon from '@mui/icons-material/Room';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { accommodationVenue } from '../../schema/accommodationVenue';
import {accommodation} from "../../schema/accommodation";

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

export const AccommodationVenues = ({
  schema,
  values,
  tableType,
}: {
  schema: any;
  values: any;
  tableType: string;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [properties, setProperties] = useState<any>([]);
  const [venueAddress, setVenueAddress] = useState<any>(undefined);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = React.useState<
    any
  >({
    schema: accommodationVenue,
    row: {},
  });

  const debouncedOnChange = debounce(handleDebouncedOnChange, 500);
  function handleDebouncedOnChange(address: string, value: any) {
    handleChange(address, value);
  }

  const fetchVenues = useCallback(() => {
    const searchParams = new URLSearchParams({});

    api
      .get(`/accommodation-addresses/${values.id}`, searchParams)
      .then((res: any) => {
        setProperties(res);
      });
  }, []);

  const handleChange = useCallback(
    async (item: any, data: any) => {
      address.client
        .update(item?.id, data)
        .then((res: any) => {
          /* const oldProperties = [...properties];
          const newRows = oldProperties.map((row: any) => {
            return row.id === image.id ? res : row;
          });
          setProperties(newRows);*/
        })
        .catch((e: any) => {
          console.error(e);
        });
    },
    [properties]
  );

  useEffect(() => {
    fetchVenues();
  }, []);

  return (
    <>
      <Stack width={'50%'}>
        <Stack direction={'row'}>
          <Button
            sx={{
              marginBottom: '10px',
            }}
            variant="contained"
            onClick={() => {
              setCurrentAddNewPaneEntity({
                row: {
                  id: 'new',
                  accommodation: {
                    id: values?.id,
                    name: values?.name,
                  },
                },
                schema: accommodationVenue,
              });
            }}
          >
            Add New Address
          </Button>
        </Stack>
      </Stack>

      {loading ? (
        <>
          <Skeleton
            sx={{
              mt: '20px',
            }}
            variant="rounded"
            width={'100%'}
            height={350}
          />
        </>
      ) : (
        <>
          {properties.map((venueItem: any) => {

            return (
              <Stack
                component="section"
                direction={'row'}
                sx={{
                  p: '20px',
                  background: '#fff',
                  borderRadius: '10px',
                  mt: '20px',
                  width: '100%',
                }}
              >
                <Stack width={'100%'}>
                  <Stack
                    direction={'row'}
                    gap={0}
                    mt={'10px'}
                    sx={{
                      '& > span': {},
                    }}
                  >
                    <span className={''}>
                      <RoomIcon
                        sx={{
                          color: '#256861',
                        }}
                      />{' '}
                      <span className={'text-[#3d3d3d]'}>
                        Address: {venueItem?.address_line1}
                      </span>
                    </span>
                  </Stack>
                  <Stack
                    direction={'row'}
                    gap={0}
                    mt={'10px'}
                    sx={{
                      '& > span': {},
                    }}
                  >
                    <span className={''}>
                      <GpsFixedIcon
                        sx={{
                          color: '#256861',
                        }}
                      />{' '}
                      <span className={'text-[#3d3d3d]'}>
                        Coordinates: {venueItem?.coordinates}
                      </span>
                    </span>
                  </Stack>

                  <Stack mt={'20px'}>
                    <MapGoogle coordinates={[]} address={venueItem} />
                  </Stack>
                </Stack>
                <Stack>
                  <MoreOptions
                    clickOnEdit={() => {

                      const tempVenueItem:any = {...venueItem};
                      tempVenueItem.accommodation = {
                        id: values?.id,
                        name: values?.name,
                      };

                      setOpenedSlidingPane({
                        schema: accommodationVenue,
                        row: tempVenueItem,
                      });
                    }}
                    clickOnDelete={() => {
                      setOpenConfirmDialog({
                        row: venueItem,
                        schema: accommodationVenue,
                      });
                    }}
                  />
                </Stack>
              </Stack>
            );
          })}
        </>
      )}

      {currentAddNewPaneEntity?.row?.id && (
        <>
          <SlidingPaneAddNew
            mainSchema={accommodation}
            schema={currentAddNewPaneEntity?.schema}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              fetchVenues();
              setCurrentAddNewPaneEntity({
                schema: accommodationVenue,
                row: {},
                key: undefined,
              });
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              fetchVenues();
              setCurrentAddNewPaneEntity({
                schema: accommodationVenue,
                row: {},
                key: undefined,
              });
            }}
          />
        </>
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => {
          setOpenConfirmDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure you want to delete it?'}
        </DialogTitle>
        <DialogActions>
          <MUIButton
            onClick={() => {
              setOpenConfirmDialog(false);
            }}
          >
            Cancel
          </MUIButton>
          <MUIButton
            variant={'contained'}
            color={'error'}
            onClick={() => {
              const deletedRow = openConfirmDialog?.row;

              api.delete(`/accommodation-addresses/${deletedRow.pivot.accommodation_id}/${deletedRow.id}`, { id: deletedRow.id })
                .then((res: any) => {
                  fetchVenues();
                  toaster.show({
                    intent: 'success',
                    message: `Successfully deleted ${address.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                  });
                  setOpenConfirmDialog(false);
                })
                .catch((e: any) => {
                  console.log(e);
                  toaster.show({
                    icon: 'error',
                    message: `Error: Unable to delete ${address.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                    intent: 'danger',
                  });
                });
            }}
            autoFocus
          >
            Delete
          </MUIButton>
        </DialogActions>
      </Dialog>

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            fetchVenues();
            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            fetchVenues();
            setOpenedSlidingPane({});
          }}
        />
      )}
    </>
  );
};
